import { render, staticRenderFns } from "./Part7.vue?vue&type=template&id=bb037c08&scoped=true"
import script from "./Part7.vue?vue&type=script&lang=js"
export * from "./Part7.vue?vue&type=script&lang=js"
import style0 from "./Part7.vue?vue&type=style&index=0&id=bb037c08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb037c08",
  null
  
)

export default component.exports